export default __webpack_public_path__ + "static/char-s-56-zh-Hant-617ffd9225ba46bc79d31651dd071567.webp";